//
// PreferredSizeBehaviorType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var PreferredSizeBehaviorType = {
    IGNORESIZE:0,
    HONORSIZE:1
};
export default PreferredSizeBehaviorType;
